<section class="terms">
  <div class="terms__container">

    <!-- Header -->
    <div class="terms__header">
      <p class="terms__meta">{{ 'terms_conditions.meta' | translate }}</p>
      <h1 class="terms__title">
        {{ 'terms_conditions.title_1' | translate }}
        <span class="terms__title-accent">{{ 'terms_conditions.title_2' | translate }}</span>
      </h1>
      <p class="terms__updated">{{ 'terms_conditions.updated' | translate }}</p>
    </div>

    <!-- Sections -->
    <div class="terms__content">

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">01</span> {{ 'terms_conditions.s1_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s1_body_1' | translate }}</p>
        <p class="terms__section-body">{{ 'terms_conditions.s1_body_2' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">02</span> {{ 'terms_conditions.s2_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s2_body_1' | translate }}</p>
        <p class="terms__section-body">{{ 'terms_conditions.s2_body_2' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">03</span> {{ 'terms_conditions.s3_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s3_body_1' | translate }}</p>
        <p class="terms__section-body">{{ 'terms_conditions.s3_body_2' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">04</span> {{ 'terms_conditions.s4_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s4_body_1' | translate }}</p>
        <p class="terms__section-body">{{ 'terms_conditions.s4_body_2' | translate }}</p>
        <p class="terms__section-body">{{ 'terms_conditions.s4_body_3' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">05</span> {{ 'terms_conditions.s5_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s5_body_1' | translate }}</p>
        <p class="terms__section-body">{{ 'terms_conditions.s5_body_2' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">06</span> {{ 'terms_conditions.s6_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s6_body_1' | translate }}</p>
        <p class="terms__section-body">{{ 'terms_conditions.s6_body_2' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">07</span> {{ 'terms_conditions.s7_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s7_body_1' | translate }}</p>
        <p class="terms__section-body">{{ 'terms_conditions.s7_body_2' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">08</span> {{ 'terms_conditions.s8_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s8_body_1' | translate }}</p>
        <p class="terms__section-body">{{ 'terms_conditions.s8_body_2' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">09</span> {{ 'terms_conditions.s9_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s9_body' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">10</span> {{ 'terms_conditions.s10_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s10_body_1' | translate }}</p>
        <p class="terms__section-body">{{ 'terms_conditions.s10_body_2' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">11</span> {{ 'terms_conditions.s11_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s11_body_1' | translate }}</p>
        <p class="terms__section-body">{{ 'terms_conditions.s11_body_2' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">12</span> {{ 'terms_conditions.s12_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s12_body' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">13</span> {{ 'terms_conditions.s13_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s13_body' | translate }}</p>
      </div>

      <div class="terms__section">
        <h2 class="terms__section-title"><span class="terms__section-num">14</span> {{ 'terms_conditions.s14_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s14_body' | translate }}</p>
      </div>

      <!-- Contact -->
      <div class="terms__contact">
        <h2 class="terms__contact-title"><span class="terms__section-num">15</span> {{ 'terms_conditions.s15_title' | translate }}</h2>
        <p class="terms__section-body">{{ 'terms_conditions.s15_body' | translate }}</p>
        <p [innerHTML]="'terms_conditions.s15_email' | translate"></p>
        <!-- <a class="terms__contact-email" href="mailto:{{ 'terms_conditions.s15_email' | translate }}">{{  }}</a> -->
      </div>

    </div>
  </div>
</section>
